import React from "react";

export default function Pagination({
    page,
    setPage,
    pageSize,
    dataLength,
    loading,
}) {
    return (
        <div className="flex items-center justify-between px-4 py-3 border-t border-gray-200 text-xs text-gray-700 bg-white rounded-b-2xl">
            <div className="text-gray-700">
                Trang <span className="font-semibold text-primary">{page}</span>
            </div>

            <div className="flex items-center gap-2">
                <button
                    onClick={() => setPage((p) => Math.max(1, p - 1))}
                    disabled={page === 1 || loading}
                    className="px-3 py-1 rounded-lg border border-gray-300 hover:bg-primary hover:text-white hover:border-primary disabled:opacity-40 disabled:cursor-not-allowed transition-colors text-gray-700"
                >
                    Trang trước
                </button>

                <button
                    onClick={() => {
                        if (dataLength >= pageSize && !loading) {
                            setPage((p) => p + 1);
                        }
                    }}
                    disabled={dataLength < pageSize || loading}
                    className="px-3 py-1 rounded-lg border border-gray-300 hover:bg-primary hover:text-white hover:border-primary disabled:opacity-40 disabled:cursor-not-allowed transition-colors text-gray-700"
                >
                    Trang sau
                </button>
            </div>
        </div>
    );
}
